// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1xlef","title":"Info_title__32ziF","selects":"Info_selects__36x4V","requiredAsterisk":"Info_requiredAsterisk__2IRvk"};